export enum CyberAttackManagementStatusEnum {
    Done = "Done",
    Pending = "Pending",
    PendingUnmanage = "PendingUnmanage",
    NeedAction = "NeedAction"
}